<template>
  <el-dialog
    id="edit-modal"
    class="form-modal"
    :visible.sync="editVisible"
    v-loading="editProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="edit-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">View / Edit Routing Profile</h1>
        <div class="modal-actions col-2">
          <el-button type="primary" @click="editOperation">Save</el-button>
          <el-button type="default" @click="cancelOperation"> Cancel</el-button>
        </div>
      </div>
    </div>

    <recent-audits service="Routing Profile" :record="selectedRoutingProfile" />
    <el-tabs v-model="activeTabName">
      <el-tab-pane name="general" label="General">
        <el-form>
          <el-input v-model="editForm.name" placeholder="Enter name">
            <template slot="prefix">Name</template>
          </el-input>
          <el-input v-model="editForm.description" placeholder="Enter description">
            <template slot="prefix">Description</template>
          </el-input>
        </el-form>
      </el-tab-pane>
      <el-tab-pane name="dialingrules" label="Dialing Rules">
        <el-form>
          <div
            class="dialing-rule-container"
            v-for="(dialingRule, i) in editForm.dialingRules"
            :key="i"
          >
            <h3 class="form-section-header dialing-rule-title">
              Rule {{ i + 1 }}
            </h3>
            <div class="inline-form-group">
              <el-col :span="10">
                <el-input v-model="dialingRule.name" placeholder="Enter name">
                  <template slot="prefix">Name</template>
                </el-input>
              </el-col>
              <el-col :span="1" />
              <el-col :span="10">
                <el-input v-model="dialingRule.regex" placeholder="Enter regex">
                  <template slot="prefix">Regex</template>
                </el-input>
              </el-col>
            </div>
            <div class="inline-form-group">
              <el-col :span="10">
                <dads-select
                  v-model="dialingRule.providerId"
                  placeholder="Provider"
                  filterable
                >
                  <el-option
                    v-for="(item, i) in providerOptions"
                    :key="i"
                    :label="item.name"
                    :value="item.id"
                  />
                  <template slot="prefix">Provider</template>
                </dads-select>
              </el-col>
              <el-col :span="1" />
              <el-col :span="10">
                <el-select
                  v-model="dialingRule.priority"
                  placeholder="Select priority"
                >
                  <el-option
                    v-for="(n, i) in 20"
                    :key="i"
                    :label="n"
                    :value="n"
                  />
                  <template slot="prefix">Priority</template>
                </el-select>
              </el-col>
            </div>
            <div class="inline-form-group">
              <el-col :span="10">
                <el-input
                  v-model="dialingRule.addDigits"
                  placeholder="Enter digits to add"
                >
                  <template slot="prefix">Digits to add</template>
                </el-input>
              </el-col>
              <el-col :span="1" />
              <el-col :span="10">
                <el-input
                  v-model="dialingRule.delDigits"
                  placeholder="Enter digits to delete"
                >
                  <template slot="prefix">Digits to delete</template>
                </el-input>
              </el-col>
            </div>
            <el-checkbox v-model="dialingRule.emergencyRoute">Label as emergency route</el-checkbox>
            <el-tooltip
              v-if="i === editForm.dialingRules.length - 1"
              effect="dark"
              :content="`Remove rule ${i + 1}`"
              placement="top"
              class="dialing-rule-delete-btn"
            >
              <el-button
                @click="removeDialingRule(i)"
                icon="el-icon-delete"
              />
            </el-tooltip>
          </div>

          <el-button class="dialing-rule-add-btn" @click="addDialingRule">Add rule</el-button>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>

import DadsSelect from '@/components/select';
import RecentAudits from '@/components/RecentAudits';

export default {
  name: "RoutingProfileEditForm",
  props: {
    editVisible: { required: true },
    editProcessing: { required: true },
    providerOptions: { required: true },
    clearFormFields: { required: true },
    selectedRoutingProfile: {
      required: true
    }
  },

  components: {DadsSelect, RecentAudits},

  data() {
    return {
      activeTabName: "general",
      invalidRegex: false,
      editForm: {
        name: "",
        description: "",
        dialingRules: [
          {
            name: "",
            regex: "",
            providerId: null,
            emergencyRoute: false,
            priority: null,
            addDigits: "",
            delDigits: "",
            noId: 0,
            masklen: 0,
            weight: 1,
            uselcr: "",
            usepin: ""
          }
        ]
      }
    };
  },

  watch: {
    clearFormFields(value) {
      if (value) {
        this.clearFields();
      }
    },

    selectedRoutingProfile(val) {
      if (val) {
        const { name, description, rules } = val;
        this.editForm.name = name;
        this.editForm.description = description;

        console.log(rules);

        if (rules.length > 0) {
          this.editForm.dialingRules = rules.map(rule => {
            return {
              name: rule.name,
              regex: rule.regex,
              providerId: rule.providerId,
              emergencyRoute: rule.emergencyRoute === "on",
              priority: rule.priority,
              addDigits: rule.addDigits,
              delDigits: rule.delDigits,
              noId: rule.noId,
              masklen: rule.masklen,
              weight: rule.weight,
              uselcr: rule.uselcr,
              usepin: rule.usepin
            };
          });
        }
      }
    }
  },

  methods: {
    addDialingRule() {
      this.editForm.dialingRules.push({
        name: "",
        regex: "",
        providerId: null,
        emergencyRoute: false,
        priority: null,
        addDigits: "",
        delDigits: "",
        noId: 0,
        masklen: 0,
        weight: 1,
        uselcr: "",
        usepin: ""
      });
    },

    removeDialingRule(idx) {
      this.editForm.dialingRules.splice(idx, 1);
      if (this.editForm.dialingRules.length === 0) {
        this.addDialingRule();
      }
    },

    editOperation() {
      const editBody = { ...this.editForm };

      let invalidForm = false;
      for (let i = 0; i < editBody.dialingRules.length; i++) {
        const rule = editBody.dialingRules[i];

        rule.emergencyRoute = rule.emergencyRoute ? "on" : "";

        rule.delDigits = rule.delDigits === "" ? 0 : rule.delDigits;

        try {
          new RegExp(rule.regex);
        } catch (error) {
          this.$notify({
            title: `Invalid Regex for Rule ${i + 1}.`,
            message: "Please provide a valid regex.",
            type: "error"
          });
          invalidForm = true;
        }

        if (invalidForm) {
          break;
        }
      }

      if (invalidForm) {
        return;
      }

      console.log(editBody);

      this.$emit("editOperation", editBody);
    },

    cancelOperation() {
      this.$emit("cancelOperation", "edit");
    },

    clearFields() {
      this.activeTabName = "general";
      this.editForm = {
        name: "",
        description: "",
        dialingRules: [
          {
            name: "",
            regex: "",
            providerId: null,
            emergencyRoute: false,
            priority: null,
            addDigits: "",
            delDigits: "",
            noId: 0,
            masklen: 0,
            weight: 1,
            uselcr: "",
            usepin: ""
          }
        ]
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.el-tabs {
  max-width: 600px;
  margin: 25px auto 0 auto;
}

.el-form {
  margin-top: 0;
}

.el-checkbox {
  margin-left: 0;
}

.dialing-rule-container {
  position: relative;
}

.dialing-rule-delete-btn {
  position: absolute;
  right: 0;
  top: 48%;
  transform: translateY(-50%);
}

.dialing-rule-title {
  margin: 20px 0 0 0;
}

.dialing-rule-add-btn {
  margin-top: 20px;
}
</style>
